import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {ShiftWithDriverAndVehicleModel} from '../../../models/shift.model';
import { DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-confirm-delete-shift-dialog',
  templateUrl: './confirm-delete-shift-dialog.component.html',
  styleUrls: ['./confirm-delete-shift-dialog.component.scss'],
  imports: [MatDialogTitle, MatDialogContent, DatePipe, MatDialogActions, MatButton, MatDialogClose],
})
export class ConfirmDeleteShiftDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteShiftDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShiftWithDriverAndVehicleModel
  ) {}

  handleCancelClick(): void {
    this.dialogRef.close();
  }
}
